import { Directive } from '@angular/core';

@Directive({
  selector: '[qpointMapFooterOverlay]',
  standalone: true
})
export class MapFooterOverlayDirective {

  constructor() { }

}
